import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const TagsLockedNote = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  color: ${colors.base.warning};
  font-size: 12px;
  line-height: 16px;
  text-transform: none;

  & svg {
    font-size: 16px;
    flex-shrink: 0;
  }
`;

export {
  TagsLockedNote,
};
